import { Asterisk } from "lucide-react";

const ITEMS = [
  "ROBINETTERIE",
  "MEUBLES DE SALLE DE BAIN",
  "LITS COFFRES",
  "LIVRAISON PARTOUT À DAKAR",
  "PAIEMENT WAVE & ORANGE MONEY",
  "SAMA KEUR, SA KER GI",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="mx-8 whitespace-nowrap font-display text-2xl italic tracking-tight text-sand/90 md:text-3xl">{t}</span>
        <Asterisk className="h-6 w-6 shrink-0 text-ochre" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-terracotta-dark bg-terracotta py-5">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
